export default __webpack_public_path__ + "static/media/stone_click.d3c7e4be.mp3";